import colors from '../../../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        accountRecoveryBox: {
            display: 'flex',
            flexDirection: 'row',
            padding: '16px'
        },
        accountRecoveryIcon: {
            color: colors[mode].recoveryIcon,
            height: '20px',
            width: '20px'
        },
        accountRecoveryOption: {
            '&:hover': {
                cursor: 'pointer',
                opacity: 0.9
            },
            alignItems: 'center',
            background: colors[mode].primaryBackground,
            border: `1px solid ${colors[mode].recoveryBorder}`,
            borderRadius: '2px',
            display: 'flex',
            flexDirection: 'row',
            fontFamily: 'Roboto',
            fontSize: '20px',
            fontWeight: 500,
            justifyContent: 'space-between',
            lineHeight: '24px',
            padding: '16px 16px',
            width: '90%'
        },
        accountRecoveryOptionFr: {
            // width: '310px'
        },
        accountRecoveryOptions: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            justifyContent: 'center',
            marginBottom: '32px',
            marginTop: '32px',
            width: '100%'
        },
        accountRecoveryOptionSelected: {
            background: colors[mode].skeletonInsightsBackground,
            border: `1px solid ${colors[mode].recoveryBorder}`,
            color: '#003168',
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '24px',
        },
        accountRecoveryPhoneNumber: {
            color: colors[mode].primaryText,
            fontSize: '18px',
            letterSpacing: '0.46px',
            lineHeight: '20px',
            marginLeft: '12px',
        },
        accountRecoveryType: {
            color: colors[mode].primaryText,
            fontSize: '20px',
            letterSpacing: '0.46px',
            lineHeight: '24px',
            marginLeft: '12px',
        },
        actionRow: {
            '& > button': {
                marginLeft: 'auto'
            },
            height: '100%',
            justifyContent: 'flex-end',
            padding: '16px 24px'
        },
        buttonContainer: {
            '@media screen and (max-width: 320px)': {
                paddingBottom: '20px'
            },
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            justifyContent: 'flex-end',
        },
        buttonSkip: {
            '&.MuiButton-root': {
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                padding: '8px 16px',
                textTransform: 'uppercase',
                width: 'auto',
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)'
            }
        },
        buttonSubmit: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                border: '1px solid #FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                padding: '8px 16px',
                textTransform: 'uppercase',
                width: 'auto'
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)',
                opacity: '0.5'
            }
        },
        radio: {
            '&.Mui-checked': {
                color: colors[mode].recoveryIcon
            },
            color: colors[mode].primaryText,
        },
        recoveryContainer: {
            alignItems: 'flex-start',
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: '315px',
            width: '100%',
        },
        warningLine: {
            background: colors[mode].primaryBackground,
            color: colors[mode].secondaryText,
            display: 'flex',
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            padding: '16px 24px'
        }
    }
}

export default styles